import classNames from 'classnames';
import type { FC } from 'react';
import { Text } from '../text/text';
import styles from './required-hint.module.css';

type RequiredHintProps = {
  className?: string;
  bottomSpacing?: boolean;
};

export const RequiredHint: FC<RequiredHintProps> = ({ className, bottomSpacing }) => {
  return (
    <Text className={classNames(styles.wrapper, className, { [styles['bottom-spacing']]: bottomSpacing })}>
      Felder mit Sternchen (<span>*</span>) sind erforderlich
    </Text>
  );
};
